import { FormInstance } from '@arco-design/web-react';
import isEqual from 'lodash/isEqual';
import { useEffect, useRef } from 'react';

/**
 * 用于同步外部状态到 Form 的 Hook
 * @param form Form 实例
 * @param externalState 外部状态，当此状态变化时，会更新 Form 的值
 * @description 适用场景：表单作为数据展示或初始化
 */
export function useFormSyncState<T>(form: FormInstance<T>, externalState: T) {
  const prevStateRef = useRef<T>(externalState);

  useEffect(() => {
    if (!isEqual(prevStateRef.current, externalState)) {
      form.setFieldsValue(externalState as any); // 类型是 DeepPartial<T>，这里简洁起见
      prevStateRef.current = externalState;
    }
  }, [externalState, form]);
}
